import $ from 'jquery';
import slick from  '../vendors/slider.min';

import imagesLoaded  from 'imagesloaded';

class BjzmScripts {
	
	constructor() {
		this.getBody = $('body');

		 this.do_hamburger();
		 // this.doSliders();
		 this.isHamburgerOpen = false;
		 this.setTouchScreenClasses(".button, .navigation__link");
		 this.mobileHeader = $(".header--mobile");
		 this.doHomeAnimations();
		 // this.doMobileMenu();
		 this.heroAnimation();
		 this.doRealtorPortalMenu();
		 this.doBjzmPopups();

		 this.handleEmailTelClicks();


		 $(".header__condo-select-link--active").on('click', function(e){
		 	e.preventDefault();
		 	if( !$(this).closest('.header__condo-select').hasClass('active') ) {
		 		$(this).closest('.header__condo-select').addClass('active');
		 	}
		 	else {
		 		$(this).closest('.header__condo-select').removeClass('active');
		 	}
		 });

	}

	handleEmailTelClicks(e) {
		$('a[href^="mailto:"]').on('click', function(e){
			gtag('event', 'conversion', { 
				'allow_custom_scripts': true,
				'send_to': 'DC-9245067/invmedia/mobil0+unique'
			});
		});
		$('a[href^="tel:"]').on('click', function(e){
			gtag('event', 'conversion', {
				'allow_custom_scripts': true,
				'send_to': 'DC-9245067/invmedia/mobil0+unique'
			});
		});
	}

	doRealtorPortalMenu() {
	    $( ".realtor-portal__nav-list-item" ).click(function() {
	        $(this).addClass('realtor-portal__nav-list-item--active').siblings().removeClass('realtor-portal__nav-list-item--active');
	    });
	    // smoothScroll
	    /*$('a[href*="#"]').on('click', function (e) {
	    	e.preventDefault();

	    	$('html, body').animate({
	    		scrollTop: $($(this).attr('href')).offset();
	    	}, 500, 'linear');
	    });*/
	}

	heroAnimation() {

		setTimeout(function(){

			$('.hero-wrapper').addClass('hero-wrapper--visible');
			
		}, 500);
	}

	doHomeAnimations() {
			
		if( $(".home-hero").length > 0 ) {
			
			imagesLoaded( $(".home-hero"), function() {	

				setTimeout(() => {
					$(".home-hero").removeClass('home-hero--hidden');
				}, 300);

				setTimeout(() => {
					$(".header--main").removeClass('hidden-home');
				}, 900);

				setTimeout(() => {
					$(".home-hero").addClass('home-hero--animating');
				}, 400);

				setTimeout(function(){
					$(".home-slider-content").addClass('show');
					$(".bjzm-slideshow__nav--home").addClass('show');
				}, 1300);
				setTimeout(function(){
					$(".home-slider-content__item--0").addClass('home-slider-content__item--active');
				}, 1300);
				setTimeout(function(){
					$(".bjzm-slideshow__content-item--prev").removeClass('swipe-in');
				}, 1700);

			} );
		}

		$(window).scroll(function() {
			if($(window).scrollTop() + $(window).height() > ($(document).height() - 100 )) {
				$(".footer__ribbons").addClass('footer__ribbons--animating');
			}
		});
		
		if( $(".page-hero__ribbons").length > 0 ) {
			setTimeout(() => {
				$(".hero").addClass('hero--animating');
			}, 800);
		}

	}

	do_hamburger() {
		var self = this;
		$(".hamburger__inner").click(function(e){
			e.preventDefault();
			if( self.isHamburgerOpen ) {
				self.closeMobileMenu();
			}
			else {
				self.openMobileMenu();
			}
		})
	}

	doMobileMenu() {

		$('#mobile-menu .secondary-pages > a').click(function(e){
		    e.preventDefault();
		    // $(this).siblings().toggleClass('submenu--active');
		    $(this).closest('.menu-item-has-children').toggleClass('active-submenu');
		});
	}

	doSliders() {
		if( $(".bjzm-slideshow__list").length > 0 ) {
			
			$(".bjzm-slideshow__list").slick({ 
				dots: false,
				centerPadding: '20px',
		 		slidesToShow: 1,
		 		variableWidth: true,
		 		adaptiveHeight: true,
		 		arrows: false,
	            dotsClass: 'custom_paging',
	            infinite: true,
	            autoplay: true,
	            autoplaySpeed: 3000,
	            pauseOnHover: true,
	            useCSS: true,
	            centerMode: true,
	            cssEase: 'ease-in-out'
		 	});
			$(".bjzm-slideshow__nav-link--prev").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickPrev');
			})
			$(".bjzm-slideshow__nav-link--next").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickNext');
			})
		} 	
	}

	openMobileMenu() {
		this.mobileHeader.addClass("header--mobile-menu-active");
		this.getBody.addClass("scroll-lock");
		this.isHamburgerOpen = true;
	}

	closeMobileMenu() {
		this.mobileHeader.removeClass("header--mobile-menu-active");
		this.getBody.removeClass("scroll-lock");
		this.isHamburgerOpen = false;
	}


	is_touch_device() {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	}

	getTouchClass() {
		return ( this.is_touch_device() ) ? ' touch-screen' : ' desktop-screen';
	}

	setTouchScreenClasses(selectors) {
		var classes = this.getTouchClass();
		$(selectors).addClass( classes );
	}

	doBjzmPopups() {
		var closeButton = `
					<div class="bjzm-popup__close"><a href="#" class="bjzm-popup__close-link close-popup image-popup-close">Close</a></div>

		`;

		$('.image-popup').magnificPopup({
			type: 'image',
			closeOnContentClick: true,
			removalDelay: 300,
			mainClass: 'mfp-img-mobile mfp-fade',
			image: {
				verticalFit: true
			},
			 callbacks: {
			 	beforeOpen: function() {
			 		$("body").addClass('promo-popup-open');
			 		$('.image-popup-close').trigger('click');
			 	},
			 	open: function() {
			 		$('body.promo-popup-open .mfp-image-holder .mfp-close').html('Close');
			 	},
			 	afterClose: function() {
			 		$("body").removeClass('promo-popup-open');
			 	}
			 }

		});

		if( $("#promo-popup").length > 0 ) {
			setTimeout(function(){
				$.magnificPopup.open({
					items: {
						src: '#promo-popup'
					},
					type: 'inline',
					removalDelay: 300,
					 mainClass: 'mfp-fade',
					 callbacks: {
					 	beforeOpen: function() {
					 		$("body").addClass('promo-popup-open');
					 	},
					 	afterClose: function() {
					 		$("body").removeClass('promo-popup-open');
					 	}
					 }
				});
				$(".close-popup").on('click', function(e){
					e.preventDefault();
					$("#promo-popup").magnificPopup('close');
				})
			}, 9000);	
		}

		if( $(".content-block#location").length > 0 ) {
			$("#location .button").on('click', function(e){
				e.preventDefault();
				$.magnificPopup.open({
					items: {
						src: '#condo-popup'
					},
					type: 'inline',
					removalDelay: 300,
					 mainClass: 'mfp-fade'
				});
				$(".close-popup").on('click', function(e){
					e.preventDefault();
					$("#condo-popup").magnificPopup('close');
				})
			})
		}


	}

	
}

module.exports = BjzmScripts;









